export const GET_PROFILE = 'PROFILE/GET_PROFILE';
export const UPDATE_PROFILE = 'PROFILE/UPDATE_PROFILE';

export const GET_BUSINESS = 'BUSINESS/get_business';
export const UPDATE_BUSINESS = 'BUSINESS/update_business';

export const GENERATE_2FA = 'PROFILE/enable_2fa';
export const ENABLE_2FA = 'PROFILE/enable_2fa';
export const DISABLE_2FA = 'PROFILE/disable_2fa';

export const SEND_EMAIL = 'PROFILE/send_email';
export const VALIDATE_EMAIL = 'PROFILE/validate_email';


export const mfaOptions = [
    { label: 'Authenticator App', value: 'Authenticator App' },
    { label: 'Email Authentication', value: 'Email Authentication' },
];

